import React from 'react';
import { LogIn, ShieldAlert, Monitor, MousePointerClick, History } from 'lucide-react';
import { TIPOS, fmtDuracion, fmtFechaHora, dispositivoTxt } from './actividadUtils';

const ICONOS = { LOGIN: LogIn, LOGIN_FALLIDO: ShieldAlert, VISTA: Monitor, ACCION: MousePointerClick };
const TONOS = {
  LOGIN: 'bg-teal-50 text-teal-700', LOGIN_FALLIDO: 'bg-rose-50 text-rose-600',
  VISTA: 'bg-sky-50 text-sky-700', ACCION: 'bg-amber-50 text-amber-700',
};

const detalle = (e) => {
  if (e.tipo === 'VISTA') return `${e.modulo ? `${e.modulo} · ` : ''}${e.seccion || e.ruta}${e.duracion_seg ? ` · ${fmtDuracion(e.duracion_seg)}` : ''}`;
  if (e.tipo === 'ACCION') {
    if (e.origen === 'historial') return `${e.descripcion}${e.seccion ? ` · ${e.seccion}` : ''}`;
    return `${e.descripcion}${e.seccion ? ` en ${e.seccion}` : ''}`;
  }
  return [dispositivoTxt(e), e.ip].filter(Boolean).join(' · ');
};

export const EventoItem = ({ e, mostrarUsuario = true, testid }) => {
  const Icon = e.origen === 'historial' ? History : ICONOS[e.tipo] || Monitor;
  const fallo = e.tipo === 'ACCION' && e.status >= 400;
  return (
    <li className="flex items-start gap-3 py-2.5" data-testid={testid}>
      <span className={`mt-0.5 h-7 w-7 shrink-0 rounded-lg flex items-center justify-center ${TONOS[e.tipo] || 'bg-slate-100 text-slate-600'}`}>
        <Icon size={14} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm text-slate-800">
          {mostrarUsuario && <span className="font-semibold">{e.nombre || e.email || 'Desconocido'} · </span>}
          <span className="text-slate-500">{TIPOS[e.tipo]}{e.origen === 'historial' ? ' (historial)' : ''}</span>
          {fallo && <span className="ml-1.5 text-[11px] font-semibold text-rose-600">error {e.status}</span>}
        </p>
        <p className="text-xs text-slate-500 truncate" title={e.path || ''}>{detalle(e) || '—'}</p>
        {e.tipo === 'ACCION' && e.path && <p className="text-[11px] font-mono text-slate-400 truncate">{e.metodo} {e.path}</p>}
      </div>
      <span className="text-[11px] text-slate-400 tabular-nums whitespace-nowrap">{fmtFechaHora(e.fecha)}</span>
    </li>
  );
};

export default EventoItem;
